/*
 * Collection sidebar (2026-10-04; the old side panel came from the uninstalled Rapid Search app).
 * Markup: snippets/as-coll-sidebar.liquid inside sections/main-collection.liquid. Everything is event delegation on
 * document, because assets/as-type-view.js re-renders the whole .main-collection when a type tab is clicked.
 *  - Drawer (< 1025px): [data-cs-open] opens #coll-side; scrim, close button and Esc close it; focus is kept inside.
 *  - Filters: a GET form. Desktop applies each change at once; in the drawer the "Show results" button applies.
 *    Empty price boxes are left out of the URL.
 *  - Search in this collection: filters the cards on the page as you type (one-type grids first load their remaining
 *    pages through as-type-view.js), and offers the full /search for the term. Enter runs the full search.
 */
(function () {
  'use strict';
  var desk = window.matchMedia ? window.matchMedia('(min-width: 1025px)') : { matches: true };
  var lastOpener = null;
  var slice = function (l) { return Array.prototype.slice.call(l); };

  function side() { return document.querySelector('[data-cs-side]'); }
  function scrim() { return document.querySelector('.cs-scrim'); }

  function open(btn) {
    var s = side(); if (!s) return;
    lastOpener = btn || null;
    s.classList.add('is-open');
    s.setAttribute('role', 'dialog');
    s.setAttribute('aria-modal', 'true');
    var sc = scrim(); if (sc) sc.hidden = false;
    document.documentElement.classList.add('cs-lock');
    slice(document.querySelectorAll('[data-cs-open]')).forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var c = s.querySelector('[data-cs-close]');
    setTimeout(function () { (c || s).focus(); }, 30);
  }
  function close() {
    var s = side(); if (!s || !s.classList.contains('is-open')) return;
    s.classList.remove('is-open');
    s.removeAttribute('role');
    s.removeAttribute('aria-modal');
    var sc = scrim(); if (sc) sc.hidden = true;
    document.documentElement.classList.remove('cs-lock');
    slice(document.querySelectorAll('[data-cs-open]')).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var o = lastOpener && document.contains(lastOpener) ? lastOpener : document.querySelector('[data-cs-open]');
    if (o) o.focus();
  }
  function isDrawer() { var s = side(); return !!(s && s.classList.contains('is-open')); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest && t.closest('[data-cs-open]');
    if (o) { e.preventDefault(); open(o); return; }
    if (t.closest && t.closest('[data-cs-close]')) { e.preventDefault(); close(); return; }
    var m = t.closest && t.closest('[data-cs-more]');
    if (m) {
      var list = m.parentNode.querySelector('[data-cs-list]');
      var on = !list.classList.contains('is-expanded');
      list.classList.toggle('is-expanded', on);
      m.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!m.getAttribute('data-label')) m.setAttribute('data-label', m.textContent);
      m.textContent = on ? 'Show fewer' : m.getAttribute('data-label');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (!isDrawer()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var s = side();
    var f = slice(s.querySelectorAll('a[href], button, input:not([type="hidden"]), summary'))
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  if (desk.addEventListener) desk.addEventListener('change', function () { if (desk.matches) close(); });

  // ── Filters ──
  function filterUrl(form) {
    var params = new URLSearchParams();
    Array.from(new FormData(form).entries()).forEach(function (kv) {
      if (String(kv[1]).trim() === '') return;
      params.append(kv[0], kv[1]);
    });
    var qs = params.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  }
  function go(form) {
    document.documentElement.classList.add('tv-loading');
    location.href = filterUrl(form);
  }
  document.addEventListener('change', function (e) {
    var form = e.target.closest && e.target.closest('[data-cs-filters]');
    if (!form || isDrawer() || !desk.matches) return;
    go(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches && form.matches('[data-cs-filters]')) { e.preventDefault(); go(form); return; }
    if (form.matches && form.matches('[data-cs-search-form]')) {
      var q = form.querySelector('[data-cs-q]');
      if (!q || !q.value.trim()) { e.preventDefault(); if (q) q.focus(); }
    }
  });

  // Plain URL of a one-type grid: its filters count every product of the collection. as-type-view.js fetches the
  // type's lead-tag page anyway; take that page's exact filters (same form action) once, if the visitor has not
  // touched the form yet.
  document.addEventListener('astv:page', function (e) {
    var cur = document.querySelector('[data-cs-filters][data-cs-exact="false"]');
    if (!cur || cur.__csTouched) return;
    var fresh = e.detail && e.detail.doc && e.detail.doc.querySelector('[data-cs-filters][data-cs-exact="true"]');
    if (!fresh || fresh.getAttribute('action') !== cur.getAttribute('action')) return;
    var open = {};
    slice(cur.querySelectorAll('details')).forEach(function (d, i) { open[(d.querySelector('summary') || {}).textContent] = d.open; });
    var node = document.importNode(fresh, true);
    slice(node.querySelectorAll('details')).forEach(function (d) {
      var k = (d.querySelector('summary') || {}).textContent;
      if (k in open) d.open = open[k];
    });
    cur.parentNode.replaceChild(node, cur);
  });
  document.addEventListener('focusin', function (e) {
    var f = e.target.closest && e.target.closest('[data-cs-filters]');
    if (f) f.__csTouched = true;
  });

  // ── Search in this collection ──
  var timer = 0;
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, ''); }
  function cardText(c) {
    if (c.__csText == null) {
      var t = c.querySelector('.product-card-title');
      c.__csText = norm((t ? t.textContent : c.textContent) + ' ' + (c.getAttribute('data-product-type-label') || ''));
    }
    return c.__csText;
  }
  function applyFilter(form, term) {
    var grid = document.getElementById('product-grid');
    var status = form.querySelector('[data-cs-q-status]');
    var all = form.querySelector('[data-cs-q-all]');
    if (!grid) return;
    var words = norm(term).split(/\s+/).filter(Boolean);
    var cards = slice(grid.querySelectorAll('.product-card'));
    var n = 0;
    cards.forEach(function (c) {
      var hit = !words.length || words.every(function (w) { return cardText(c).indexOf(w) !== -1; });
      c.classList.toggle('cs-miss', !hit);
      if (hit) n++;
    });
    // grouped decor view: hide a section heading whose cards all miss
    slice(grid.querySelectorAll('.cs-group-head')).forEach(function (h) {
      var any = false, el = h.nextElementSibling;
      while (el && !el.classList.contains('cs-group-head')) {
        if (el.classList.contains('product-card') && !el.classList.contains('cs-miss')) { any = true; break; }
        el = el.nextElementSibling;
      }
      h.classList.toggle('cs-miss', words.length > 0 && !any);
    });
    var more = document.querySelector('[data-tv-more]');
    if (more && words.length) more.hidden = true;
    if (!status) return;
    if (!words.length) {
      status.textContent = '';
      if (all) all.hidden = true;
      return;
    }
    status.textContent = n === 0 ? 'No matches in this collection.' : (n + (n === 1 ? ' match' : ' matches') + ' in this collection');
    if (all) {
      all.hidden = false;
      all.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'search?q=' + encodeURIComponent(term.trim()) + '&options%5Bprefix%5D=last';
      all.textContent = 'Search the whole shop for “' + term.trim() + '”';
    }
  }
  document.addEventListener('input', function (e) {
    var q = e.target.closest && e.target.closest('[data-cs-q]');
    if (!q) return;
    var form = q.form;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var term = q.value;
      var grid = document.getElementById('product-grid');
      if (term.trim() && grid && grid.__tvLoadAll && !grid.__csAll) {
        var status = form.querySelector('[data-cs-q-status]');
        if (status) status.textContent = 'Searching every design…';
        if (!grid.__csLoading) {
          grid.__csLoading = grid.__tvLoadAll().then(function () { grid.__csAll = true; });
        }
        grid.__csLoading.then(function () { applyFilter(form, q.value); });
        applyFilter(form, term);
        if (status) status.textContent = 'Searching every design…';
        return;
      }
      applyFilter(form, term);
    }, 180);
  });
})();
